import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef, NbMenuItem } from "@nebular/theme";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { EMAIL_PATTERN } from "../../@auth/components/constants";

import Enrollment from "../../models/enrollment.model";
import Profile from "../../models/profile.model";
import { ProfileService } from "../../services/profile.service";

@Component({
  selector: "ngx-dialog-invite-student",
  templateUrl: "dialog-invite-student.component.html",
  styleUrls: ["dialog-invite-student.component.scss"],
})
export class DialogInviteStudentComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() students?: Enrollment[] = [];
  @Input() uid?: string;

  diaForm: FormGroup;
  submitted = false;
  loading = false;
  strSearch = "";
  lastSearch = "";
  message = "";

  profile: Profile = new Profile();
  loadedProfile = false;
  profileItems: NbMenuItem[] = [];

  constructor(
    protected ref: NbDialogRef<DialogInviteStudentComponent>,
    private fb: FormBuilder,
    private profileApi: ProfileService
  ) {}

  ngOnInit() {
    const emailValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
      Validators.pattern(EMAIL_PATTERN),
    ];

    this.diaForm = this.fb.group({
      strSearch: ["", emailValidators],
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }

  search() {
    if (this.strSearch != this.lastSearch && this.diaForm.valid) {
      this.loading = true;
      this.submitted = true;
      this.loadedProfile = false;

      this.strSearch = this.strSearch.replace(" ", "").trim();
      console.log(
        "🚀 ~ DialogInviteStudentComponent ~ search ~ this.strSearch:",
        this.strSearch
      );
      this.message = "";
      this.profileApi
        .getUserByEmail(this.strSearch)
        .snapshotChanges(["added", "removed"])
        .pipe(
          map((changes) =>
            changes.map((c) => ({
              id: c.payload.doc.id,
              ...c.payload.doc.data(),
            }))
          ),
          takeUntil(this.destroy$)
        )
        .subscribe((data) => {
          console.log("getUserByEmail:", data);

          this.lastSearch = this.strSearch;

          if (data.length > 0) {
            const item = _.find(this.students, ["createdBy", data[0].uid]);
            if (item) {
              this.message = "Học viên này đã tham gia khóa học";
            }

            if (data[0].uid == this.uid) {
              this.message = "Email này đang là quản lý khóa học";
            }

            this.profile = data[0];

            this.profileItems = [
              {
                title: `${this.profile.email}`,
                icon: "email-outline",
              },
              {
                title: this.profile.displayName,
                icon: "at-outline",
              },
              {
                title: this.profile.fullName,
                icon: "person-outline",
              },
              // {
              //   title: this.profile.dob.toLocaleDateString(),
              //   icon: "calendar-outline",
              // },
              {
                title: this.profile.mobile,
                icon: "phone-call-outline",
              },
            ];

            this.loadedProfile = true;
          } else {
            this.profile = null;
            this.profileItems = [];
            this.message = "Không tìm thấy thông tin học viên";
          }

          this.loading = false;
          this.submitted = false;
        });
    }
  }

  submit() {
    this.submitted = true;
    if (this.loadedProfile && this.profile && this.message === "") {
      this.ref.close(this.profile);
    }
  }
}
